import compact from 'lodash/compact';
import flattenDeep from 'lodash/flattenDeep';
import forEach from 'lodash/forEach';
import isUndefined from 'lodash/isUndefined';
import map from 'lodash/map';
import sortBy from 'lodash/sortBy';

export const initialAmenities = {
    valet: {
        count: 0,
        slug: 'valet',
        name: 'Valet',
    },
    'self-park': {
        count: 0,
        slug: 'self-park',
        name: 'Self Park',
    },
    'covered-parking': {
        count: 0,
        slug: 'covered-parking',
        name: 'Covered Parking',
    },
    mobile: {
        count: 0,
        slug: 'mobile',
        name: 'Mobile Pass Accepted',
    },
    'in-out': {
        count: 0,
        slug: 'in-out',
        name: 'In and Out Allowed',
    },
};

export const initialReservationTypes = {
    all: {
        slug: 'all',
        name: 'All Availability',
    },
    // eslint-disable-next-line quote-props
    '247': {
        slug: '247',
        name: '24/7 Regular Parking',
        description: 'Unlimited parking 7 days a week, 24 hours a day.',
        count: 0,
        related: [],
        active: false,
    },
    // eslint-disable-next-line camelcase
    daytime_only: {
        slug: 'daytime_only',
        name: 'Daytime Only Parking',
        description:
            'Great option if you drive to work but don’t need to park overnight.',
        count: 0,
        related: ['daytime_and_247_weekend', '247'],
        active: false,
    },
    // eslint-disable-next-line camelcase
    daytime_and_247_weekend: {
        slug: 'daytime_and_247_weekend',
        name: 'Daytime + 24/7 Weekend Parking',
        description:
            'Great option if you drive to work during the week and need unlimited parking during the weekend.',
        count: 0,
        related: ['247'],
        active: false,
    },
    // eslint-disable-next-line camelcase
    nights_only: {
        slug: 'nights_only',
        name: 'Nights Only Parking',
        description:
            'Great  option if you need to park overnight, but use your car during the day.',
        count: 0,
        related: ['nights_and_247_weekend', '247'],
        active: false,
    },
    // eslint-disable-next-line camelcase
    nights_and_247_weekend: {
        slug: 'nights_and_247_weekend',
        name: 'Nights + 24/7 Weekend Parking',
        description:
            'Great option if you need to park overnight and throughout the weekend.',
        count: 0,
        related: ['247'],
        active: false,
    },
    storage: {
        slug: 'storage',
        name: 'Storage',
        description:
            'Safe and secure storage if you want to drop off your car for an extended period of time',
        count: 0,
        related: [],
        active: false,
    },
    valet: {
        slug: 'valet',
        name: 'On-Demand Valet',
        description:
            'Book through SpotHero and and a third party valet will pick up/drop off your car at your desired location. Restrictions apply.',
        count: 0,
        related: [],
        active: false,
    },
};

export const setAmenities = ({spots, amenities, rateType = 'hourly_rates'}) => {
    // reset amenity counts
    forEach(amenities, amenity => {
        amenity.count = 0;
    });

    // populate amenities
    forEach(spots, spot => {
        const spotAmenities = [];

        forEach(spot[rateType], rate => {
            if (!rate.hidden) {
                forEach(rate.amenities, amenity => {
                    // eslint-disable-line max-nested-callbacks
                    if (spotAmenities.indexOf(amenity.slug) < 0) {
                        if (isUndefined(amenities[amenity.slug])) {
                            amenities[amenity.slug] = {
                                slug: amenity.slug,
                                name: amenity.name,
                                count: 1,
                            };
                        } else {
                            amenities[amenity.slug].count++;
                        }

                        spotAmenities.push(amenity.slug);
                    }
                });
            }
        });
    });

    return amenities;
};

export const setReservationTypes = ({spots, reservationTypes}) => {
    // reset all reservation types to inactive
    forEach(reservationTypes, reservationType => {
        if (reservationType.slug !== 'all') {
            reservationType.active = false;
        }
    });

    // populate reservation types
    forEach(spots, spot => {
        forEach(spot.monthly_rates, rate => {
            if (rate.reservation_type !== 'all') {
                if (!isUndefined(reservationTypes[rate.reservation_type])) {
                    reservationTypes[rate.reservation_type].active = true;
                }
            }
        });
    });

    return reservationTypes;
};

export const setPriceRange = ({spots, price}) => {
    const range = {
        priceLow: 0,
        priceHigh: 0,
    };

    if (!spots.length) {
        return range;
    }

    const prices = sortBy(
        compact(
            flattenDeep(
                map(spots, spot => {
                    return spot.selectedRate.display_price;
                })
            )
        ),
        newPrice => {
            return newPrice;
        }
    );

    if (prices.length) {
        range.priceLow = Math.ceil(prices[0] / 100);
        range.priceHigh = Math.ceil(prices[prices.length - 1] / 100);
    }

    if (price && price < range.priceHigh) {
        range.priceHigh = price;
    }

    return range;
};
